import { isObject } from './functions';

// If this function works fine, should replace the one in BlockDao
export function recursivelyRemoveSysFromEntry(entry) {
  var _entry$sys, _entry$sys2, _entry$sys2$contentTy, _entry$sys2$contentTy2;
  if (Array.isArray(entry)) {
    return entry.map(x => recursivelyRemoveSysFromEntry(x));
  }
  if (!isObject(entry)) {
    return entry;
  }
  const sysType = entry == null ? void 0 : (_entry$sys = entry.sys) == null ? void 0 : _entry$sys.type;
  const contentType = (entry == null ? void 0 : (_entry$sys2 = entry.sys) == null ? void 0 : (_entry$sys2$contentTy = _entry$sys2.contentType) == null ? void 0 : (_entry$sys2$contentTy2 = _entry$sys2$contentTy.sys) == null ? void 0 : _entry$sys2$contentTy2.id) || (sysType === 'Asset' ? sysType : undefined);
  const fields = entry == null ? void 0 : entry.fields;
  if (contentType && fields) {
    var _entry$sys3;
    const _sysRemovedFields = recursivelyRemoveSysFromEntry(fields);
    const revision = contentType == 'staticImage' ? entry == null ? void 0 : (_entry$sys3 = entry.sys) == null ? void 0 : _entry$sys3.revision : undefined;
    return {
      fields: {
        ..._sysRemovedFields,
        contentType,
        revision
      }
    };
  } else {
    const keys = Object.keys(entry);
    const _entry = {};
    for (const key of keys) {
      _entry[key] = recursivelyRemoveSysFromEntry(entry[key]);
    }
    return _entry;
  }
}